export var UNDERSTANDING_SECTION = "UNDERSTANDING_SECTION";
export var UNDERSTANDING_SECTION_DISPLAY_DATA = "UNDERSTANDING_SECTION_DISPLAY_DATA";
export var UNDERSTANDING_SECTION_ERROR = "UNDERSTANDING_SECTION_ERROR";
export var UNDERSTANDINGSECTION_HIDE_ERROR = "UNDERSTANDING_SECTION_HIDE_ERROR";
export var UNDERSTANDING_SECTION_START_LOADER = "UNDERSTANDING_SECTION_START_LOADER";
export var UNDERSTANDING_SECTION_STOP_LOADER = "UNDERSTANDING_SECTION_STOP_LOADER";
